import styled from '@emotion/styled';

export const FiltersRowWrapperStyled = styled.div`
  margin-bottom: 16px;
  border: 1px solid ${({ theme }) => theme.palette.custom['gray-60']};
  border-radius: 8px;
`;
